module.exports = __webpack_public_path__ + "static/img/templateLogo1.11cc9942.png";